import {
    UPDATE_DISCOUNTS_REDUCER,
    UPDATE_CARS_TYPE_REDUCER,
} from 'store/actionTypes';
import {
    ActionType,
    CarTypesData,
    DiscountReducerModal
} from 'utils/modals';

export const CarsTypeReducer = (
    state: CarTypesData = new CarTypesData(),
    action: ActionType,
) => {
    switch (action.type) {
        case UPDATE_CARS_TYPE_REDUCER:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export const DiscountReducer = (
    state: DiscountReducerModal = new DiscountReducerModal(),
    action: ActionType,
) => {
    switch (action.type) {
        case UPDATE_DISCOUNTS_REDUCER:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};